import {useMemo, useRef} from 'react'

import {InternalColumn} from '../types.js'
import {isSortable, sortRows} from '../utils.js'

/**
 * The rows sorted on a column, sorted again only when the rows, the sort column, the direction, the column's dropdown
 * option or what the column sorts on (its sort function, else text function, else key) change. A new sort function
 * means the values it reads may have changed (customers that loaded after the rows), so callers keep their column
 * functions the same while those values are (see TableColumn).
 */
export default function useTableSort<T>(rows: T[], column: InternalColumn<T> | undefined, descending: boolean, option: string | undefined): T[] {
    const columnRef = useRef(column)
    columnRef.current = column

    const sortable = column && isSortable(column)
    const sortId = sortable ? column.id : undefined
    const sortValue = sortable ? column.sort ?? column.text ?? column.key : undefined

    return useMemo(() => sortRows(rows, columnRef.current, descending, option), [rows, sortId, sortValue, descending, option])
}
